import React from "react";

const GRAD = "linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%)";

/**
 * Catches render-time errors anywhere in the tree so a single broken page
 * shows a readable message instead of a blank white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // Keep a trace in the console for debugging
    // eslint-disable-next-line no-console
    console.error("[Neobk.Pro] UI error caught by ErrorBoundary:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, info: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const msg = this.state.error?.message || String(this.state.error || "Erreur inconnue");
    const stack = this.state.info?.componentStack || this.state.error?.stack || "";

    return (
      <div style={{ minHeight: "100vh", background: "#f4f6ff", fontFamily: "Inter, system-ui, sans-serif", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem 1.5rem" }}>
        <div style={{ width: "100%", maxWidth: "560px", background: "#fff", border: "1px solid #e2e8f8", borderRadius: "24px", padding: "2.5rem", boxShadow: "0 8px 40px rgba(59,130,246,.1)" }}>
          <div style={{ width: "48px", height: "48px", borderRadius: "14px", background: GRAD, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: "22px", marginBottom: "1.25rem" }}>!</div>
          <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1.6rem", letterSpacing: "-0.02em", color: "#0d0d1a", marginBottom: "0.5rem" }}>
            Une erreur est survenue
          </h1>
          <p style={{ color: "#4a4a6a", fontSize: "14px", marginBottom: "1.25rem", lineHeight: 1.6 }}>
            Cette page a rencontré un problème. Le détail ci-dessous aide à le corriger.
          </p>

          <div style={{ background: "rgba(239,68,68,.06)", border: "1px solid rgba(239,68,68,.2)", borderRadius: "12px", padding: "12px 14px", marginBottom: "1.25rem" }}>
            <div style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#ef4444", marginBottom: "4px" }}>Message</div>
            <div style={{ fontFamily: "monospace", fontSize: "13px", color: "#0d0d1a", wordBreak: "break-word" }}>{msg}</div>
          </div>

          {stack && (
            <details style={{ marginBottom: "1.25rem" }}>
              <summary style={{ cursor: "pointer", fontSize: "12px", fontWeight: 600, color: "#4a4a6a" }}>Détails techniques</summary>
              <pre style={{ marginTop: "8px", fontSize: "11px", color: "#4a4a6a", background: "#f9faff", border: "1px solid #e2e8f8", borderRadius: "8px", padding: "10px", overflowX: "auto", maxHeight: "200px", whiteSpace: "pre-wrap" }}>{stack}</pre>
            </details>
          )}

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <button onClick={this.handleReset}
              style={{ flex: 1, minWidth: "140px", padding: "12px", borderRadius: "12px", border: "none", cursor: "pointer", fontWeight: 600, fontSize: "14px", color: "#fff", background: GRAD, boxShadow: "0 8px 24px rgba(59,130,246,.35)" }}>
              Réessayer
            </button>
            <button onClick={() => { window.location.href = "/"; }}
              style={{ flex: 1, minWidth: "140px", padding: "12px", borderRadius: "12px", border: "1px solid #e2e8f8", cursor: "pointer", fontWeight: 600, fontSize: "14px", color: "#0d0d1a", background: "#fff" }}>
              Retour à l'accueil
            </button>
          </div>
        </div>
      </div>
    );
  }
}
